<button mat-raised-button color="primary" (click)="createKampanje()">
  Create Kampanje
</button>
<div class="week-container">
  <div class="week-column" *ngFor="let day of daysOfWeek">
    <h3 class="day-header">{{ day.name }}</h3>



    <!-- Display subscription cards for this day -->
    <ng-container *ngIf="kampanjeByDay[day.index]?.length; else noSubscriptions">
      <mat-card *ngFor="let kampanje of kampanjeByDay[day.index]" class="subscription-card"
        [ngStyle]="{ 'background-color': getCardColor(kampanje) }">
        <mat-card-header>
          <mat-card-title>{{ kampanje.name }}</mat-card-title>
          <mat-card-subtitle>{{ kampanje.dayOfWeek }}</mat-card-subtitle>
        </mat-card-header>
        <mat-card-content>
          <p><strong>Start Time:</strong> {{ kampanje.startTime }}</p>
          <p><strong>End Time:</strong> {{ kampanje.endTime }}</p>
          <p><strong>Percent:</strong> {{ kampanje.percentage }}</p>
          <p><strong>Applies to:</strong> {{ targetSummary(kampanje) }}</p>
          <p><strong>Systems:</strong> {{ kampanje.systems?.length || 0 }}</p>
        </mat-card-content>
        <mat-card-actions>
          <div class="example-button-row">
            <button mat-flat-button color="primary" (click)="editKampanje(kampanje)">Edit</button>
          <button mat-flat-button color="warn" (click)="deleteKampanje(kampanje)">Delete</button>
          </div>
         
        </mat-card-actions>
      </mat-card>
    </ng-container>

    <!-- Template if no subscriptions exist for the day -->
    <ng-template #noSubscriptions>
      <p class="no-data">No subscriptions</p>
    </ng-template>
  </div>
</div>
